import React, { useState, useMemo } from "react";
import "../../pages/companyMaster/companyMaster.scss";
import Avatar from "../common/Avatar";
import { NotFound } from "../../components/common/NotFound";
import PaginationComponent from "../common/PaginationComponent";
import SkeletonCustomerMasterGrid from "../common/skeletonCustomerMasterGrid";

const CompanyGrid = (props) => {
  const {
    filteredResults,
    handleEdit,
    handleDelete,
    handleView,
    loading,
    menuRights,
    moduleName,
  } = props;

  const [count, setCount] = useState(25);
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = count;

  const currentTableData = useMemo(() => {
    if (filteredResults?.length <= pageSize) setCurrentPage(1);
    else if (currentPage > Math.ceil(filteredResults?.length / pageSize)) {
      setCurrentPage(1);
    }

    const firstPageIndex = (currentPage - 1) * pageSize;
    const lastPageIndex = firstPageIndex + pageSize;
    return filteredResults?.slice(firstPageIndex, lastPageIndex) || [];
  }, [currentPage, filteredResults, count]);

  return (
    <>
      <div className="row company-table-row mb-4rem">
        <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
          {loading === true ? (
            <>
                 <SkeletonCustomerMasterGrid rows={12} />
            </>
          ) : currentTableData.length > 0 ? (
            <div className="card mt-0 company-list-card">
              <div className="card-body">
                <div className="table-responsive company-table-responsive">
                  <table className="table table-borderless table-list company-table-list">
                    <thead>
                      <tr>
                        <th><div>COMPANY</div></th>
                        <th><div>WEBSITE</div></th>
                        <th><div>COUNTRY</div></th>
                        <th><div>AUTHORIZED PERSON</div></th>
                        <th><div>EMAIL</div></th>
                        <th><div>PHONE NUMBER</div></th>
                        <th><div>STATUS</div></th>
                        <th><div>ACTIONS</div></th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentTableData?.map((item, index) => (
                        <tr key={item?.id || index}>
                          <td
                            onClick={menuRights?.canView === true ? () => handleView(item) : undefined}
                            className={menuRights?.canView === true ? "clickable-cell" : ""}
                          >
                            <div className="company-cell">
                              <Avatar preName={item?.companyName} />
                              <h4 title={item?.companyName}>{item?.companyName || "-"}</h4>
                            </div>
                          </td>
                          <td><h5 title={item?.website}>{item?.website || "-"}</h5></td>
                          <td><h5 title={item?.countryName}>{item?.countryName || "-"}</h5></td>
                          <td><h5 title={item?.authorizedPerson}>{item?.authorizedPerson || "-"}</h5></td>
                          <td><h5 title={item?.email}>{item?.email || "-"}</h5></td>
                          <td><h5 title={item?.phone}>{item?.phone || "-"}</h5></td>
                          <td>
                            <button
                              type="button"
                              className={item?.status === "Active" ? "btn active-btn" : "btn inactive-btn"}
                            >
                              {item?.status || "-"}
                            </button>
                          </td>
                          <td>
                            {(menuRights?.canEdit === true || menuRights?.canDelete === true) && (
                              <div className="dropdown dropleft text-align action-menu">
                                <span
                                  className="action-icon"
                                  title="Actions"
                                  id={`companyDropdownMenuButton-${item?.id || index}`}
                                  data-toggle="dropdown"
                                  aria-haspopup="false"
                                  aria-expanded="false"
                                >
                                  <i className="fas fa-ellipsis-v" />
                                </span>
                                <div
                                  className="dropdown-menu p-0"
                                  aria-labelledby={`companyDropdownMenuButton-${item?.id || index}`}
                                >
                                  <ul>
                                    {menuRights?.canEdit === true && (
                                      <li onClick={() => handleEdit(item)}>
                                        <span>
                                          <i className="far fa-edit"></i> Edit
                                        </span>
                                      </li>
                                    )}
                                    {menuRights?.canDelete === true && (
                                      <li onClick={() => handleDelete(item)}>
                                        <span>
                                          <i className="far fa-trash-alt mr-1"></i> Delete
                                        </span>
                                      </li>
                                    )}
                                  </ul>
                                </div>
                              </div>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          ) : (
            <NotFound />
          )}
        </div>
      </div>
      {currentTableData.length > 0 && (
        <PaginationComponent
          count={count}
          setCount={setCount}
          pageSize={pageSize}
          currentPage={currentPage}
          filteredResults={filteredResults}
          setCurrentPage={setCurrentPage}
        />
      )}
    </>
  );
};

export default CompanyGrid;
